<script lang="ts" setup>
import type { FTab } from '@components/types'

defineProps<{
  id: string
  tabs: FTab[]
  tabPanelsClass?: string
  tabListClass?: string
  tabListCenter?: boolean
  defaultIndex?: number
}>()
</script>

<template>
  <HeadlessTabGroup :default-index>
    <HeadlessTabList
      :data-test="getCypressId('tabs')"
      py-12px lg:pb-0px flex-wrap flex
      gap-8px lg:gap-4px
      fubex-rounded-md text-center
      font-400 paragraph-sm lg:paragraph-md text-neutral-900
      w-full items-center
      lg:rounded-b-0
      lg:border-b-3px lg:border-primary-500 dark:lg:border-primary-300
      :class="[
        tabListCenter ? 'justify-center' : 'justify-start',
        tabListClass,
      ]"
    >
      <HeadlessTab
        v-for="tab in tabs"
        :key="tab.title"
        v-slot="{ selected }"
        as="template"
      >
        <button
          p-6px px-12px md:py-12px md:px-16px fubex-rounded-md transition-all cursor-pointer duration-250 lg:rounded-b-0 focus-visible:outline-none
          :class="{
            'tab-active': selected,
            'bg-neutral-100 dark:bg-neutral-200 hover:bg-neutral-200 dark:hover:bg-neutral-300': !selected,
            'flex gap-8px items-center': tab.icon,
          }"
        >
          <UnoIcon v-if="tab.icon" :class="tab.icon" h-16px w-16px />
          {{ tab.title }}
        </button>
      </HeadlessTab>
    </HeadlessTabList>
    <HeadlessTabPanels :id="id" v-auto-animate :class="tabPanelsClass" w-full>
      <HeadlessTabPanel v-for="tab in tabs" :key="tab.title" text-start>
        <component :is="tab.component" />
      </HeadlessTabPanel>
    </HeadlessTabPanels>
  </HeadlessTabGroup>
</template>
